import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const benefits = ['Saber exactamente qué ofrecer en cada etapa.', 'Deja de buscar en Google todo el tiempo.', 'Disponer de un menú preestablecido para seguir sin tener que pensar.', 'Evita cometer errores que provoquen el rechazo de la comida.', 'Dormir plácidamente sabiendo que vas por el buen camino.'];
export function ProductIntro() {
  return <section className="py-10 md:py-20 px-5 md:px-6 bg-[#F0F8FB]" data-id="element-148">
      <div className="max-w-3xl mx-auto" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-6 md:p-12 rounded-3xl shadow-xl border border-[#A9D7E2]/30 relative overflow-hidden" data-id="element-150">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#F9A8B7]" data-id="element-151"></div>

          <h2 className="text-2xl md:text-4xl font-bold text-[#2D1F1A] mb-6 md:mb-10 leading-tight tracking-tight text-center" data-id="element-152">
            Con el <em className="text-[#F9A8B7] not-italic" data-id="element-153">Kit para Mamás</em>
            , podrás:
          </h2>

          <ul className="space-y-3 md:space-y-4" data-id="element-154">
            {benefits.map((benefit, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className="flex items-start gap-3 p-3 md:p-4 bg-[#FFF1F4] rounded-2xl border border-[#F9A8B7]/20" data-id="element-155">
                <div className="flex-shrink-0 mt-0.5" data-id="element-156">
                  <div className="bg-[#A9D7E2] p-1 rounded-full" data-id="element-157">
                    <CheckIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-white" strokeWidth={3} data-id="element-158" />
                  </div>
                </div>
                <span className="text-sm md:text-lg text-[#2D1F1A] leading-snug font-medium" data-id="element-159">
                  {benefit}
                </span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}